import httpService from "./httpService";

export default {

  findByDocIdAndRelationType(docId, relationType) {
    return httpService.get("/vbDocUser/findByDocIdAndRelationType", {
      params: {docId, relationType}
    });
  },

  markAsDaXLForBcc(id) {
    return httpService.put(`/vbDocUser/${id}/markAsDaXLForBcc`);
  },

  findByVbIncomingProcessId(processId) {
    return httpService.get("/vbDocUser/findByVbIncomingProcessId", {
      params: {processId}
    });
  },

  setStar(form) {
    return httpService.put(`/vbIsStarUser/setStar`, form);
  },

  getAllVbIsStarByUserDeptRole(userDeptRoleId) {
    return httpService.get(`/vbIsStarUser/getAllVbIsStarByUserDeptRole`, {
      params: {userDeptRoleId: userDeptRoleId}
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/vbDocUserService.js